export default function getLocalStorage( item ) {
    if (localStorage.getItem('wp_user_auth') === null) return false;
    // console.log( JSON.parse(localStorage.getItem('wp_user_auth')) );
    const storage = JSON.parse( localStorage.getItem('wp_user_auth') );

    if (typeof storage[item] !== undefined) {
        return storage[item];
    }
    return  false;
}